const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};


window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig = {
    loadedClass: 'lazyloaded',
    loadingClass: 'lazyloading',
    errorClass: 'lazyerror',
    threshold: 300,
    loadMode: 1,
    expFactor: 1.5,
    sizes: 'auto',
    hFac: 1,
    init: true,
    lazyClass: 'lazyload',
    preloadClass: 'lazypreload',
    debounceDelay: 50,
    rAF: true,
    polyfill: true
};
